import React, { useEffect, useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import AddDevisLineModal from './AddDevisLineModal';
import { formatCurrency } from 'pages/comptabilite/utils/functions';
import { Spinner } from 'react-bootstrap';
import CloseSquare from 'assets/customizeIcons/CloseSquare.svg';

import RemoveIcon from 'assets/customizeIcons/remove.svg';
import { ReactComponent as Empty } from 'assets/customizeIcons/emptyProduct.svg';
import { ReactComponent as Add } from 'assets/customizeIcons/AddIcon.svg';
import { COLORS } from './Mobile';

const DevisTableRow = ({ data, isDisabled, last, setData, index }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [deleteLoading, setDeleteLoading] = useState(false);
	const [error, setError] = useState(null);

	const handleDelete = () => {
		setDeleteLoading(true);
		setError(null);

		setData((prev) => {
			const lignes = prev?.lignes || [];
			const lineToDelete = lignes[index];

			if (!lineToDelete) {
				// nothing to delete
				return prev;
			}

			const deletedHT =
				(Number(lineToDelete.quantite) || 0) * (Number(lineToDelete.prixUnitaireHT) || 0);

			const newLignes = lignes.filter((_, i) => i !== index);

			// Recompute totals safely
			const newTotalHT = (Number(prev.totalHT) || 0) - deletedHT;
			const tva = Number(prev.tva) || 0;
			const newMontantTVA = newTotalHT * (tva / 100);
			const newTotalTTC = newTotalHT + newMontantTVA;

			return {
				...prev,
				updated: true,
				totalHT: Math.max(0, newTotalHT),
				montantTVA: Math.max(0, newMontantTVA),
				totalTTC: Math.max(0, newTotalTTC),
				lignes: newLignes,
			};
		});

		setDeleteLoading(false);
	};

	return (
		<>
			{/* ===== ROW ===== */}
			<div
				className='w-100'
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginTop: '10px ',
					borderRadius: 20,
					cursor: 'pointer',
				}}>
				{/* LEFT */}
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						width: '70%',
					}}>
					{/* DELETE */}
					{!isDisabled && (
						<Button
							variant='error'
							onClick={(e) => {
								e.stopPropagation();
								handleDelete();
							}}
							style={{
								padding: 0,
								marginRight: 10,
							}}>
							{deleteLoading ? (
								<Spinner animation='border' size='sm' />
							) : (
								<img src={CloseSquare} alt='remove' width={26} height={26} />
							)}
						</Button>
					)}

					{/* INFO */}
					<div onClick={() => setIsOpen(true)}>
						<div
							style={{
								fontWeight: 500,
								color: '#172B4D',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								display: '-webkit-box',
								WebkitLineClamp: 2,
								WebkitBoxOrient: 'vertical',
							}}>
							{data?.description}
						</div>
						{data?.type !== 'note' && (
							<div
								style={{
									fontSize: 13,
									color: '#7a7a7a',
								}}>
								{data?.quantite} × {formatCurrency(data?.prixUnitaireHT)}
							</div>
						)}
					</div>
				</div>

				{/* RIGHT */}
				{data?.type !== 'note' && (
					<div
						onClick={() => setIsOpen(true)}
						style={{
							width: '20%',
							textAlign: 'right',
							fontWeight: 500,
							color: '#172B4D',
						}}>
						{formatCurrency(data?.prixUnitaireHT * data?.quantite)}
					</div>
				)}
			</div>

			{/* SEPARATOR */}
			{!last && (
				<div
					style={{
						margin: '0 10px',
						borderBottom: '1px solid #ebebeb',
					}}
				/>
			)}
		</>
	);
};

const DevisTable = ({ isDisabled, card, updateLineDevis, data, taxes, setData = () => { } }) => {
	const [isLoadingTable, setIsLoadingTable] = useState(true);
	const [currentFormValue, setCurrentFormValue] = useState({});
	const [isOpen, setisOpen] = useState(false);
	const [spinner, setSpinner] = useState(false);
	const [spinnerGarantie, setSpinnerGarantie] = useState(false);
	const [editModalSimulator, setEditModalSimulator] = useState(false);
	const [totalsPrice, setTotalsPrice] = useState(0);
	const remiseList = [0, 5, 7, 10, 12, 15, 17, 20, 22, 25];
	const [subTotalHT, setSubTotalHT] = useState(0);
	const [total, setTotal] = useState(0);
	const [error, setError] = useState();
	const [taxValue, setTaxValue] = useState(0);
	const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger', 'dark'];
	const handelCancel = () => {
		setCurrentFormValue({});
		setEditModalSimulator(false);
	};
	console.log("*****", card, data)
	const handleDragEnd = (data, from, to) => {
		console.log('card', from, to, card[0]);
		const copy = card?.filter((item) => item?.deleted !== true); // Don't modify react data in-place
		const removed = copy.splice(from, 1);
		console.log('removed', removed[0]);

		copy.splice(to, 0, removed[0]); // Now insert at the new pos
		console.log('copy', copy);
		setData((prev) => ({
			...prev,
			//  updated: true,
			order_lines: copy,
		}));
	};

	// console.log("card", card[0]?.display_name);
	// console.log("data", data?.order_lines[0]?.display_name);

	const updateTax = (newTVA) => {
		console.log('newTVA', newTVA);
		let newAmountTVA = data?.totalHT * (newTVA / 100);
		let newTotal = newAmountTVA + data?.totalHT;

		setData((prev) => ({
			...prev,
			updated: true,
			totalTTC: newTotal,
			montantTVA: newAmountTVA,
			tva: newTVA,
		}));
	};

	const [createProductModalStatus, setCreateProductModalStatus] = useState(false);

	function keyExtractor(str) {
		return str;
	}

	async function onReordered(fromIndex, toIndex) {
		const copy = card?.filter((item) => item?.deleted !== true); // Don't modify react data in-place
		const removed = copy.splice(fromIndex, 1);

		copy.splice(toIndex, 0, removed[0]); // Now insert at the new pos
		setData(copy);
	}

	useEffect(() => {
		console.log("data", data)
	}, []);

	return (
		<div style={{ margin: '20px 0' }}>
			{/* ===== TITLE ===== */}
			<div>
				<h5 style={{ fontWeight: 500, color: '#172B4D' }}>Lignes de commande</h5>
			</div>

			{/* ===== LIST ===== */}
			{card?.filter((i) => i?.deleted !== true).length > 0 ? (
				<div style={{ marginTop: 10 }}>
					{card?.map((item, index) => {
						return (
							<div key={index}>
								<div
									onClick={() => updateLineDevis({ ...item, index: index })}
									style={{
										display: 'flex',
										alignItems: 'center',
										padding: 10,
										cursor: 'pointer',
										// background: '#f8f9fe',
										borderRadius: 12,
									}}>
									<DevisTableRow
										index={index}
										data={item}
										isDisabled={isDisabled}
										setData={setData}
										last={card.length == index + 1}
									/>
								</div>

								<div
									style={{
										borderBottom: '1px solid #ebebeb',
										margin: '10px',
									}}
								/>
							</div>
						);
					})}
				</div>
			) : (
				<>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							padding: 10,
							margin: '10px 0',
							borderRadius: 20,
							color: '#172B4D',
						}}>
						<Empty fill={COLORS.ERROR} width={30} height={30} />
						Aucun produit
					</div>

					<div
						style={{
							borderBottom: '1px solid #ebebeb',
							margin: '0 10px',
						}}
					/>
				</>
			)}

			{/* ===== ADD LINE ===== */}
			{!isDisabled && (
				<div
					onClick={() => {
						setCreateProductModalStatus(true);
						console.log('clickiiiiddd');
					}}
					style={{
						display: 'flex',
						alignItems: 'center',
						padding: 10,
						margin: '10px 0',
						borderRadius: 20,
						cursor: 'pointer',
					}}>
					<Add fill={COLORS.SUCCESS} width={30} height={30} />
					<span style={{ color: '#172B4D' }}>Ajouter une ligne</span>
				</div>
			)}

			{/* ===== TOTALS ===== */}
			<div style={{ marginTop: 15 }}>
				<TotalRow label='Sous-total H.T' value={data?.totalHT} />

				{/* TVA */}
				{!isDisabled ? (
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							marginBottom: 5,
						}}>
						<span>TVA</span>

						<div style={{ display: 'flex', alignItems: 'center' }}>
							<Dropdown>
								<Dropdown.Toggle size='sm' variant='light'>
									{data?.tva}%
								</Dropdown.Toggle>

								<Dropdown.Menu>
									{taxes?.map((t) => (
										<Dropdown.Item key={t} onClick={() => updateTax(t)}>
											{t}%
										</Dropdown.Item>
									))}
								</Dropdown.Menu>
							</Dropdown>

							<span style={{ marginLeft: 10 }}>
								{formatCurrency(data?.montantTVA)}
							</span>
						</div>
					</div>
				) : (
					<TotalRow label={`TVA : ${data?.tva}`} value={data?.montantTVA} />
				)}
				{/* 
			
				{!isDisabled ? (
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<span>Remise</span>

						<div style={{ display: 'flex', alignItems: 'center' }}>
							<Dropdown>
								<Dropdown.Toggle size='sm' variant='light'>
									{remise}%
								</Dropdown.Toggle>

								<Dropdown.Menu>
									{remiseList.map((r) => (
										<Dropdown.Item key={r} onClick={() => setRemise(r)}>
											{r}%
										</Dropdown.Item>
									))}
								</Dropdown.Menu>
							</Dropdown>

							<span style={{ marginLeft: 10 }}>
								{parseFloat(data?.montantRemise).toFixed(2)} €
							</span>
						</div>
					</div>
				) : (
					<TotalRow
						label='Remise'
						value={`${parseFloat(data?.montantRemise).toFixed(2)} €`}
					/>
				)} */}

				<div
					style={{
						borderBottom: '1px solid #ebebeb',
						margin: '10px 0',
					}}
				/>

				<TotalRow label='Total T.T.C' value={data?.totalTTC} bold />
			</div>
			{createProductModalStatus && (
				<AddDevisLineModal setVisible={setCreateProductModalStatus} setData={setData} />
			)}
		</div>
	);
};

export default DevisTable;

const TotalRow = ({ label, value, bold }) => (
	<div
		style={{
			display: 'flex',
			justifyContent: 'space-between',
			fontWeight: bold ? 700 : 400,
			marginBottom: 6,
		}}>
		<span>{label}</span>
		<span className={bold && 'fs-4'}>{formatCurrency(value)}</span>
	</div>
);
